<template>
  <div v-if="getReceivable">
    <el-row class="tile_count">
      <el-col
        :span="6"
        :xs="12"
        class="tile_stats_count">
        <span class="count_top">
          <i
            class="fa fa-file-text-o"
            aria-hidden="true">
          </i> Reference
        </span>
        <div class="count rtId">
          <p>{{ getReceivable.reference }}</p>
        </div>
      </el-col>
      <el-col
        :span="6"
        :xs="12"
        class="tile_stats_count">
        <span class="count_top">
          <i class="fa fa-usd"></i>
          Payment Status
        </span>
        <div
          :class="getReceivable.status == 'paid' ? 'green' : 'warning' "
          class="count rt-payment-status">
          <div v-if="getReceivable.status === 'paid'">
            Paid
          </div>
          <div v-if="getReceivable.status === 'pending'">
            Pending
          </div>
          <div v-if="getReceivable.status === 'partially-pending'">
            Partially Pending
          </div>
        </div>
        <span
          v-if="getReceivable.status == 'Pending'"
          class="count_bottom rt-created-date">
          Created at {{ getReceivable.createdAt | moment('DD/MM/YYYY') }}
        </span>
      </el-col>
      <el-col
        :span="6"
        :xs="12"
        class="tile_stats_count">
        <span class="count_top">
          <i class="fa fa-usd"></i>
          Total Amount
        </span>
        <div class="count rt-total-amount">
          {{ getReceivable.amount | currency }}
        </div>
        <span class="count_bottom rt-total-paid">
          Total paid: {{ getTotalPaid | currency }}
        </span>
      </el-col>
      <el-col
        :span="6"
        :xs="12"
        class="tile_stats_count">
        <span class="count_top">
          <i class="fa fa-user-o"></i>
          Customer
        </span>
        <div class="count first-name" >
          {{ getReceivable.customer.name | firstName }}
        </div>
        <span class="count_bottom last-name">
          {{ getReceivable.customer.name | lastName }}
        </span>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  filters: {
    firstName: (value) => {
      const first = value.split(' ');
      return first[0];
    },
    lastName: (value) => {
      const words = value.split(' ');
      let last = '';
      for (let i = 1; i < words.length; i += 1) {
        last += `${words[i]} `;
      }
      return last;
    },
  },
  computed: {
    ...mapGetters({
      getRTItem: 'getRTItem',
    }),
    getReceivable() {
      return this.getRTItem.data;
    },
    getTotalPaid() {
      let paymentsTotal = 0;
      if (this.getReceivable.receivableTransactions) {
        for (let i = 0; i < this.getReceivable.receivableTransactions.length; i += 1) {
          paymentsTotal += parseFloat(this.getReceivable.receivableTransactions[i].amountPaid);
        }
      }
      return paymentsTotal;
    },
  },
};
</script>

<style lang="scss" scoped>
.count {
  &.success {
    color: #5cb85c;
  }
  &.warning {
    color: #f0ad4e;
  }
}
.el-upload {
  width: 100%;
}
.full-height {
  height: 80vh;
}
.rt-supplier{
  padding-left: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/receivables/receivable/receivable-details/partials/ReceivableStatusBar.vue